import { ICssShadow } from './../ICssShadow.interface';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeScrollingTextConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeScrollingText';
  public fontFamily = 'Helvetica';
  public backgroundColor = null;
  public fontColor = '#1c2b36';
  public text = 'Enter the text you want to scroll here!';
  public scrollSpeed = 1;
  public fontSize = 10;
  public textShadows: Array<ICssShadow> = new Array<ICssShadow>();

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    // and any custom props
    obj.SeType = this.SeType;
    obj.backgroundColor = this.backgroundColor;
    obj.text = this.text;
    obj.scrollSpeed = this.scrollSpeed;
    obj.fontSize = this.fontSize;
    obj.fontColor = this.fontColor;
    obj.fontFamily = this.fontFamily;
    obj.textShadows = this.textShadows;
    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings

    // add custom props
    this.SeType = _.get(obj, 'SeType', 'SeScrollingText');
    this.backgroundColor = _.get(obj, 'backgroundColor', null);
    this.text = _.get(obj, 'text', ''); // get val in safe way with defalut
    this.scrollSpeed = _.get(obj, 'scrollSpeed', 1);
    this.fontSize = _.get(obj, 'fontSize', 10);
    this.fontColor = _.get(obj, 'fontColor', '#1c2b36');
    this.fontFamily = _.get(obj, 'fontFamily', 'Helvetica');
    this.textShadows = _.get(obj, 'textShadows', new Array<ICssShadow>());
  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }



}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-scrollingtext/se-scrolling-text-config.class.ts